import React, { useState, useRef, useEffect } from "react";
import { producaov2 as api } from "../../../../../services/apis";
import { isAuthAdmin } from "../../../../../services/auth";
import { Button, Form, Input, Divider } from "semantic-ui-react";
import TextEditor from "../../../../../components/Admin/NewTextEditor";
import * as yup from "yup";
import { toast } from "react-toastify";

import { Container, Content, Title, Field, Label } from "./styles";

import swal from "sweetalert";
import { Link, withRouter } from "react-router-dom";
import AdminMenu from "../../../../../components/Admin/MenuDetalhes/AdminMenu";

const EditarFaq = props => {
  const description = useRef("");
  const [faqTipo, setFaqTipo] = useState([]);
  const [pergunta, setPergunta] = useState("");
  const [resposta, setResposta] = useState("");
  const [tipo, setTipo] = useState(0);
  const id = props.match.params.id;

  useEffect(() => {
    loadAuth();
    loadFaq();
    loadFaqTipo();
  }, []);

  const loadAuth = async () => {
    if (!isAuthAdmin("banner\\/faq")) {
      localStorage.setItem("redirect", `/admin/`);
      window.location.href = "/login";
      return null;
    }
  };

  const loadFaq = async () => {
    await api
      .get(`/faqById/${id}`)
      .then(async res => {
        let logs = { local: "banner/faq", texto: `listou a FAQ de id=${id}` };
        await api.post("system_logs", { acao: JSON.stringify(logs) });
        setPergunta(res.data.pergunta);
        setTipo(res.data.tipo);
        setResposta(res.data.resposta);
      })
      .catch(err => {
        swal("Não foi possível carregar as categorias de tipo", err, "error");
      });
  };

  const loadFaqTipo = async () => {
    await api
      .get(`/faq-categorias`)
      .then(res => {
        setFaqTipo(res.data);
      })
      .catch(err => {
        swal("Não foi possível carregar as categorias de tipo", err, "error");
      });
  };

  const update = async () => {
    const payload = {
      pergunta: pergunta,
      resposta: description.current,
      tipo: tipo,
    };

    const faqValidation = await yup.object().shape({
      pergunta: yup
        .string("Necessário que informe a pergunta")
        .required("Necessário que informe a pergunta"),
      resposta: yup
        .string("Necessário que informe a resposta")
        .required("Necessário que informe a resposta"),
      tipo: yup
        .number("Necessário que informe o tipo")
        .required("Necessário que informe o tipo"),
    });

    try {
      await faqValidation.validate(payload, { abortEarly: true });
      api
        .put(`/admin/faq/${id}`, payload)
        .then(async res => {
          let logs = {
            local: `/faq/detalhes/${res.data.faq.id}`,
            texto: `editou a FAQ de id=${res.data.faq.id}`,
          };
          await api.post("system_logs", { acao: JSON.stringify(logs) });
          swal(" Faq atualizada com sucesso", "", "success").then(res =>
            props.history.push("/admin/faq")
          );
        })
        .catch(err => {
          swal("Não foi possível atualizar a faq", err, "").then(res =>
            props.history.push("/admin/faq")
          );
        });
    } catch (err) {
      if (err instanceof yup.ValidationError) {
        swal("Erro!", `${err}`, "error");
        return;
      }
    }
  };

  return (
    <>
      <Container>
        <AdminMenu />
        <Content>
          <Title>Editar Faq</Title>

          <Form>
            <Form.Group widths="equal">
              <Form.Field
                control={Input}
                label="Pergunta"
                placeholder="Pergunta"
                value={pergunta}
                onChange={e => setPergunta(e.target.value)}
              />
              {/* <Form.Field>
                <Label>Tipo</Label>
                <select value={tipo} onChange={e => setTipo(+e?.target?.value)}>
                  {faqTipo.map(valor => (
                    <option value={valor.id}>{valor.segmento}</option>
                  ))}
                </select>
              </Form.Field> */}
            </Form.Group>

            <Field>
              <Label>Resposta</Label>
              <TextEditor
                haveFullscreen
                default={resposta}
                text={description}
              />
            </Field>
            <Divider hidden />
            <Form.Group>
              <Form.Field control={Button} onClick={() => update()}>
                Enviar
              </Form.Field>
              <Link to="/admindev/banner/faq">
                <Button color="secondary">Cancelar</Button>
              </Link>
            </Form.Group>
          </Form>
        </Content>
      </Container>
    </>
  );
};

export default withRouter(EditarFaq);
